import axios, { AxiosResponse } from "axios";
import { configService, ObjectFromEnvelope, ArrayFromEnvelope } from "./config.service";
import { Institution } from "../models/institution-model";
import { Postal } from "../models/postal-model";
import { Holiday } from "../models/holiday";
import { SchoolClasses } from "../models/schoolClassed";
import { convertDateOnlyToUtc } from "../utils/dateUtils";
import { LogonMessage } from "../models/loginMessages-model";
import { eSoCalculatesAs } from "@/models/absenceTypes-model";
class InstitutionService {
  async fetchInstitution(institutionid: number): Promise<Institution[]> {
    const response: AxiosResponse = await axios.get<any>(
      configService.APIInstitutionUrl("institutions/" + institutionid + ".json")
    );
    const institutions: Institution[] = [];
    institutions.push(Institution.fromJSON(ObjectFromEnvelope<Institution>(response.data)));
    return institutions;
  }

  async fetchPostalDistrictById(id: number): Promise<Postal> {
    const response: AxiosResponse = await axios.get<any>(
      configService.APIInstitutionUrl("postal_districts/" + id + ".json")
    );
    return Postal.fromJSON(ObjectFromEnvelope<Postal>(response.data));
  }

  async fetchPostalDistricts(): Promise<Postal[]> {
    const response: AxiosResponse = await axios.get<any>(
      configService.APIInstitutionUrl("postal_districts.json")
    );
    return Postal.fromJSONArray(ArrayFromEnvelope<Postal>(response.data));
  }

  async fetchLoginMessages(): Promise<LogonMessage[]> {
    const response: AxiosResponse = await axios.get<LogonMessage[]>(
      configService.APIInstitutionUrl("logon_messages.json"),
      {
        params: {
          date: convertDateOnlyToUtc(new Date())
        }
      }
    );
    return LogonMessage.fromJSONArray(ArrayFromEnvelope<LogonMessage>(response.data));
  }

  async fetchInstitutionTypes(): Promise<any> {
    const response: AxiosResponse = await axios.get<any>(
      configService.APIInstitutionUrl("institution_types.json")
    );
    return response.data;
  }

  async fetchInstitutionTypeById(id: number): Promise<any> {
    const response: AxiosResponse = await axios.get<any>(
      configService.APIInstitutionUrl("institution_types/" + id + ".json")
    );
    return response.data;
  }

  async fetchSchoolClasses(): Promise<SchoolClasses[]> {
    const response: AxiosResponse = await axios.get<any>(
      configService.APIInstitutionUrl("school_classes.json"),
      {
        params: {
          institution_id: configService.institutionId()
        }
      }
    );
    return SchoolClasses.fromJSONArray(ArrayFromEnvelope<SchoolClasses>(response.data));
  }

  async fetchHolidays(year: number): Promise<Holiday[]> {
    const response: AxiosResponse = await axios.get<any>(
      configService.APIInstitutionUrl("holiday.json"),
      {
        params: {
          year: year.toString()
        }
      }
    );
    return Holiday.fromJSONArray(ArrayFromEnvelope<Holiday>(response.data));
  }

  async updateInstitution(institution: Institution): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .put<Institution>(
          configService.APIInstitutionUrl(
            "institutions/" + configService.institutionId() + ".json"
          ),
          institution
        )
        .then((response: AxiosResponse) => {
          resolve(Institution.fromJSON(ObjectFromEnvelope<Institution>(response.data)));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async updateSoCalculatesAs(as: eSoCalculatesAs, onlyFutureEmployments: boolean): Promise<void> {
    return new Promise((resolve, reject) => {
      axios
        .post(configService.APIInstitutionUrl("institutions/so_calculates_as.json"), {
          as: as,
          applicable_to: onlyFutureEmployments ? 1 : 2
        })
        .then(() => {
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}

export const institutionService: InstitutionService = new InstitutionService();
